/**
 * Video Card — YouTube Facade
 * Replaces the poster+play-button with a real YouTube iframe on first click.
 * Avoids downloading the 500 KB+ YouTube player until the user actually wants to watch.
 */
(function () {
  function buildIframe(facade) {
    var videoId = facade.dataset.videoId;
    if (!videoId) return null;
    var showControls = facade.dataset.showControls === 'true';
    var title = facade.dataset.title || '';

    var iframe = document.createElement('iframe');
    iframe.className = 'video-card__video-element';
    iframe.setAttribute('data-video', '');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.title = title;

    var params = 'enablejsapi=1&playsinline=1&autoplay=1' + (showControls ? '' : '&controls=0');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?' + params;
    return iframe;
  }

  function activate(card) {
    if (card.classList.contains('is-playing')) return;
    var facade = card.querySelector('[data-youtube-facade]');
    if (!facade) return;
    var iframe = buildIframe(facade);
    if (!iframe) return;
    facade.replaceWith(iframe);
    card.classList.add('is-playing');
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.video-card');
    if (!card) return;
    if (!card.querySelector('[data-youtube-facade]')) return;
    // Only trigger on play button or the card itself, not on title links etc.
    if (e.target.closest('[data-play-button]') || e.target === card || e.target.closest('.video-card__video-wrapper')) {
      e.preventDefault();
      activate(card);
    }
  });
})();
